var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property-value-constant"},[(_vm.isString)?_c('text-input',{staticClass:"mt-0 mb-0",attrs:{"setup":{
      'func': _vm.setValueHandler,
      'args': {
        'model': _vm.value,
        'key': 'value',
        'prefix': "constant_",
      }
    }}}):_vm._e(),(_vm.isFlag)?_c('switch-input',{staticClass:"mt-0 mb-0",attrs:{"setup":{
      func: _vm.setValueHandler,
      args: {
        model: this,
        key: 'flagValue',
        prefix: 'constant_',
      }
    }}}):_vm._e(),(_vm.isNumber)?_c('number-input',{staticClass:"mt-0 mb-0",attrs:{"setup":{
      func: _vm.setValueHandler,
      args: {
        model: _vm.value,
        key: 'value',
        prefix: 'constant_',
      }
    }}}):_vm._e(),(_vm.isFiles)?_c('upload-media-descriptors',{staticClass:"mb-5",attrs:{"value":_vm.filesViewValue,"target-id":_vm.mediaTargetId},on:{"on-files-update":function($event){_vm.value.value = JSON.stringify($event)}}}):_vm._e(),(_vm.isDate)?[(_vm.action !== _vm.PropertyActionType.Set)?_c('time-unit-input',{staticClass:"mt-0 mb-0",attrs:{"setup":{
        'func': _vm.setValueHandler,
        'args': {
          model: _vm.value,
          key: 'value',
          prefix: 'constant_',
          'min': 0,
          'units': _vm.stepUnits,
        },
      }}}):_c('date-picker-input',{attrs:{"setup":{
        'func': _vm.setValueHandler,
        'args': {
          'model': this,
          'key': 'constValue',
          'clearable': false,
          'format': _vm.timeFormat,
          'time24hr': true,
          'validation': 'required'
        },
      }}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }